import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { Loader2, ListChecks, Trash2, Mail, Phone, Calendar } from "lucide-react";

export default function WaitListHub() {
  const nav = useNavigate();
  const [tab, setTab] = useState("active");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/admin/waitlist", { params: { status: tab } });
      setRows(r.data.rows);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [tab]);

  const del = async (id, label) => {
    if (!window.confirm(`Remove ${label} from the wait list?`)) return;
    await api.delete(`/admin/waitlist/${id}`);
    await load();
  };

  return (
    <Layout>
      <div className="max-w-6xl mx-auto px-6 py-10">
        <button onClick={() => nav("/pos/dashboard")} className="label-eyebrow mb-6 inline-block" data-testid="wl-hub-back">← Back</button>
        <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
          <h1 className="font-display text-4xl font-black inline-flex items-center gap-3"><ListChecks size={26} /> Wait List</h1>
          <span className="text-sm" style={{ color: "var(--ab-text-muted)" }} data-testid="wl-hub-count">{rows.length} {tab}</span>
        </div>

        <div className="flex gap-1 mb-6" style={{ borderBottom: "1px solid var(--ab-border)" }}>
          {[{ k: "active", label: "Active" }, { k: "fulfilled", label: "Fulfilled" }].map((t) => (
            <button key={t.k} onClick={() => setTab(t.k)} className="px-4 py-2 text-xs uppercase tracking-widest font-bold transition-colors"
                    style={{ color: tab === t.k ? "var(--ab-primary)" : "var(--ab-text-dim)",
                             borderBottom: tab === t.k ? "2px solid var(--ab-primary)" : "2px solid transparent",
                             marginBottom: "-1px" }}
                    data-testid={`wl-hub-tab-${t.k}`}>{t.label}</button>
          ))}
        </div>

        {loading ? <Loader2 className="animate-spin" /> : rows.length === 0 ? (
          <div className="surface p-6 text-sm" data-testid="wl-hub-empty" style={{ color: "var(--ab-text-muted)" }}>Nothing here yet.</div>
        ) : (
          <div className="space-y-3" data-testid="wl-hub-rows">
            {rows.map((e) => (
              <div key={e.id} className="surface p-4" data-testid={`wl-hub-row-${e.id}`}>
                <div className="flex items-start justify-between flex-wrap gap-3 mb-3">
                  <div className="min-w-0">
                    <div className="font-bold text-lg">{e.first_name} {e.last_name}</div>
                    <div className="text-xs inline-flex items-center gap-3 mt-1" style={{ color: "var(--ab-text-dim)" }}>
                      <span className="inline-flex items-center gap-1"><Mail size={11} /> <a href={`mailto:${e.email}`} className="hover:text-[var(--ab-primary)]">{e.email}</a></span>
                      <span className="inline-flex items-center gap-1"><Phone size={11} /> {e.phone}</span>
                      <span className="inline-flex items-center gap-1"><Calendar size={11} /> {new Date(e.created_at).toLocaleDateString()}</span>
                    </div>
                  </div>
                  <button onClick={() => del(e.id, `${e.first_name} ${e.last_name}`)} className="btn-danger inline-flex items-center gap-1 text-xs" data-testid={`wl-hub-del-${e.id}`}>
                    <Trash2 size={12} /> Remove
                  </button>
                </div>
                {tab === "fulfilled" && e.fulfilled_title && (
                  <div className="surface p-3 mb-3 inline-flex items-center gap-2" style={{ borderLeft: "3px solid var(--ab-primary)", background: "var(--ab-surface-2)" }}>
                    <div className="label-eyebrow" style={{ color: "var(--ab-primary)" }}>Fulfilled by</div>
                    <div className="text-sm"><b>{e.fulfilled_title}</b> {e.fulfilled_console && <span style={{ color: "var(--ab-text-dim)" }}>· {e.fulfilled_console}</span>}</div>
                    {e.fulfilled_at && <div className="text-xs ml-2" style={{ color: "var(--ab-text-dim)" }}>{new Date(e.fulfilled_at).toLocaleString()}</div>}
                  </div>
                )}
                <div className="grid sm:grid-cols-2 gap-2">
                  {e.items.map((it, idx) => (
                    <div key={idx} className="border px-3 py-2 text-sm" style={{ borderColor: "var(--ab-border)" }}>
                      <div className="font-bold">{it.title}</div>
                      <div className="text-[11px]" style={{ color: "var(--ab-text-dim)" }}>{it.console || "Any console"}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
